module.exports = __webpack_public_path__ + "img/Carle_Logo_BW.63c1d98b.png";